import Page from './Page';



function getFormatedDate() {
    return (new Date()).toLocaleString('pt-BR').substr(0, 17);
}

function parseDate(text) {
    var orderedDate = '';
    orderedDate += text.substr(6, 4) + '-';
    orderedDate += text.substr(3, 2) + '-';
    orderedDate += text.substr(0, 2) + ' ';
    orderedDate += text.substr(11) + ':00';
    return Date.parse(orderedDate);
}

function renderMarkdown(text) {
    if (!text) return '';
    var html = text;

    html = html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    html = html.replace(/```(\w*)\n([\s\S]*?)```/g, function (m, lang, code) {
        return '<pre class="iabenner-code"><code>' + code.replace(/\n$/, '') + '</code></pre>';
    });

    html = html.replace(/`([^`\n]+)`/g, '<code class="iabenner-inline-code">$1</code>');

    html = html.replace(/^#### (.+)$/gm, '<h6 class="iabenner-md-heading">$1</h6>');
    html = html.replace(/^### (.+)$/gm, '<h5 class="iabenner-md-heading">$1</h5>');
    html = html.replace(/^## (.+)$/gm, '<h4 class="iabenner-md-heading">$1</h4>');
    html = html.replace(/^# (.+)$/gm, '<h3 class="iabenner-md-heading">$1</h3>');

    html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/(?<!\*)\*([^*\n]+)\*(?!\*)/g, '<em>$1</em>');

    html = html.replace(/!\[([^\]]*)\]\(((?:[^()]|\([^()]*\))+)\)/g, function(m, alt, url) {
        var proxySrc = Page.getApplicationPath() + 'api/v1/iabenner/image?url=' + encodeURIComponent(url);
        return '<a href="' + url + '" target="_blank" class="iabenner-md-img-link">' +
            '<img src="' + url + '" alt="' + alt + '" class="iabenner-md-img" data-proxy-src="' + proxySrc + '" onerror="if(!this.dataset.retry){this.dataset.retry=\'1\';this.src=this.dataset.proxySrc;}else{this.style.display=\'none\';this.nextElementSibling.style.display=\'\';}" />' +
            '<span class="iabenner-md-img-placeholder" style="display:none">\uD83D\uDDBC\uFE0F ' + alt + '</span></a>';
    });

    html = html.replace(/\[([^\]]+)\]\(((?:[^()]|\([^()]*\))+)\)/g, '<a href="$2" target="_blank" class="iabenner-md-link">$1</a>');

    html = html.replace(/^(https?:\/\/[^\s]+\.(?:png|jpg|jpeg|gif|webp|svg|bmp)(?:\?[^\s]*)?)$/gim, function(m, url) {
        var proxySrc = Page.getApplicationPath() + 'api/v1/iabenner/image?url=' + encodeURIComponent(url);
        return '<a href="' + url + '" target="_blank" class="iabenner-md-img-link">' +
            '<img src="' + url + '" alt="imagem" class="iabenner-md-img" data-proxy-src="' + proxySrc + '" onerror="if(!this.dataset.retry){this.dataset.retry=\'1\';this.src=this.dataset.proxySrc;}else{this.style.display=\'none\';this.nextElementSibling.style.display=\'\';}" />' +
            '<span class="iabenner-md-img-placeholder" style="display:none">\uD83D\uDDBC\uFE0F Abrir imagem</span></a>';
    });

    var lines = html.split('\n');
    var result = [];
    var inUl = false;
    var inOl = false;

    for (var i = 0; i < lines.length; i++) {
        var line = lines[i];
        var ulMatch = line.match(/^[\-\*] (.+)$/);
        var olMatch = line.match(/^\d+\. (.+)$/);

        if (ulMatch) {
            if (!inUl) { result.push('<ul class="iabenner-md-list">'); inUl = true; }
            result.push('<li>' + ulMatch[1] + '</li>');
        } else if (olMatch) {
            if (!inOl) { result.push('<ol class="iabenner-md-list">'); inOl = true; }
            result.push('<li>' + olMatch[1] + '</li>');
        } else {
            if (inUl) { result.push('</ul>'); inUl = false; }
            if (inOl) { result.push('</ol>'); inOl = false; }
            result.push(line);
        }
    }
    if (inUl) result.push('</ul>');
    if (inOl) result.push('</ol>');

    html = result.join('\n');

    html = html.replace(/(?!<\/?(pre|ul|ol|li|h[1-6]|code|blockquote)[^>]*>)\n/g, '<br/>');
    html = html.replace(/<br\/>(\s*<(?:ul|ol|\/ul|\/ol|li|\/li|pre|\/pre|h[1-6]|\/h[1-6]))/g, '$1');
    html = html.replace(/(<\/(?:ul|ol|li|pre|h[1-6])>)\s*<br\/>/g, '$1');

    return html;
}

function ChatMessage(content, type, time, source, nickname) {
    this.type = type;
    this.content = content;
    this.time = time;
    this.nickname = nickname;
    this.source = source;
}

var IABennerChat = function () {

    var assistantNickname = 'IA Benner';
    var usernameInitials;
    var initialized = false;
    var historyIndex = 0;
    var typedMessage = "";

    var getSessionId = function () {
        return sessionStorage.getItem('iabenner-session-id');
    };

    var setSessionId = function (sessionId) {
        sessionStorage.setItem('iabenner-session-id', sessionId);
    };

    var getUsernameInfo = function () {
        var username = sessionStorage.getItem('iabenner-username');
        var currentUser = Page.userName;

        if (currentUser !== username) {
            sessionStorage.removeItem('iabenner-username-initials');
            sessionStorage.removeItem('iabenner-chat-history');
            sessionStorage.removeItem('iabenner-session-id');
            sessionStorage.setItem('iabenner-username', currentUser);
            usernameInitials = $('.dropdown-user-wes .usuario').text();
            sessionStorage.setItem('iabenner-username-initials', usernameInitials);
        } else {
            usernameInitials = sessionStorage.getItem('iabenner-username-initials');
        }

        return usernameInitials;
    };

    var create = function (chatTitle) {
        var chat =
            '<div class="row">\
    <a class="iabenner-sidebar-toggler">\
        <i class="icon-login"></i>\
    </a>\
</div>\
<div class="iabenner-sidebar-wrapper" id="iabenner-sidebar">\
    <div class="iabenner-sidebar">\
        <ul class="nav nav-tabs">\
            <li>\
                <a>' + chatTitle + '</a>\
            </li>\
        </ul>\
        <div class="tab-content">\
            <div class="tab-pane active iabenner-sidebar-chat">\
                <div class="iabenner-sidebar-list" style="position: relative; overflow: hidden;">\
                    <div class="iabenner-sidebar-chat-users" data-rail-color="#ddd" data-wrapper-class="iabenner-sidebar-list" data-initialized="1" style="overflow: hidden;">\
                        <div class="iabenner-sidebar-chat-user">\
                            <div class="iabenner-sidebar-chat-user-messages" style="overflow: hidden;"></div>\
                            <div class="iabenner-sidebar-chat-user-form">\
                                <span id="iabenner-writing-notification" class="typing" style="display:none;">\
                                    <i class="fa fa-spinner fa-pulse fa-fw"></i>Digitando...\
                                </span>\
                                <div class="input-group">\
                                    <input id="iabennerInput" type="text" class="form-control" placeholder="Digite uma mensagem..." />\
                                    <div class="input-group-btn">\
                                        <button type="button" class="btn btn-primary primary" aria-label="Enviar Mensagem">\
                                            <i class="fa fa-paper-plane"></i>\
                                        </button>\
                                    </div>\
                                </div>\
                            </div>\
                        </div>\
                    </div>\
                </div>\
            </div>\
        </div>\
    </div>\
</div>';
        $('#iabenner-chat').html(chat);
    };

    var getChatHistory = function () {
        var history = sessionStorage.getItem('iabenner-chat-history');
        if (!history) {
            return [];
        }
        history = JSON.parse(history);
        return history;
    };

    var getLastMessage = function () {
        var history = getChatHistory();
        var lastItem = null;
        if (history.length > 0) {
            lastItem = history[history.length - 1];
        }
        return lastItem;
    };

    var recoverChatHistory = function () {
        var chatHistory = getChatHistory();

        if (chatHistory.length > 0) {
            for (var i = 0; i < chatHistory.length; i++) {
                appendMessage(chatHistory[i]);
            }
        }
    };

    var preparePost = function (messageObj) {
        var tpl = '';

        switch (messageObj.type) {
            case 'break':
                tpl += '<div class="break"></div>';
                break;
            case 'text':
                tpl += prepareTextPost(messageObj);
                break;
            case 'card':
                tpl += prepareCardPost(messageObj);
                break;
            case 'link':
                tpl += prepareLinkPost(messageObj);
                break;
            case 'suggestions':
                tpl += prepareSuggestionsPost(messageObj);
                break;
        }

        return tpl;
    };

    var prepareTextPost = function (messageObj) {
        var tpl = '';
        var dir = messageObj.source === 'bot' ? 'in' : 'out';
        tpl += '<div class="post ' + dir + '">';
        if (messageObj.source !== 'bot') {
            tpl += '<div class="btn btn-icon-only btn-circle btn-sm avatar usuario">' + messageObj.nickname + '</div>';
        }
        tpl += '<div class="message">';
        tpl += '<span class="arrow"></span>';
        tpl += '<a class="name">' + messageObj.nickname + '</a>&nbsp;';
        tpl += '<span class="datetime">' + messageObj.time + '</span>';
        tpl += '<span class="body">';
        tpl += messageObj.content;
        tpl += '</span>';
        tpl += '</div>';
        tpl += '</div>';
        return tpl;
    };

    var prepareCardPost = function (messageObj) {
        var tpl = '';
        tpl += '<div class="post in">\
    <div class="message card">\
        <span class="body">';

        if (messageObj.content.image) {
            tpl += '\t\t\t<div class="image">\
                <img src="' + messageObj.content.image.imageUri + '" />\
            </div>';
        }

        if (messageObj.content.title) {
            tpl += '\t\t\t<span class="title">' + messageObj.content.title + '</span>';
        }

        if (messageObj.content.subtitle) {
            tpl += '\t\t\t<span class="subtitle">' + messageObj.content.subtitle + '</span>';
        }

        if (messageObj.content.formattedText) {
            tpl += '\t\t\t<p>' + messageObj.content.formattedText + '</p>';
        }

        tpl += '\t\t</span>\
    </div>\
</div>';
        return tpl;
    }

    var prepareLinkPost = function (messageObj) {
        var tpl = '';
        tpl += '<div class="post in">\
    <div class="message link">\
        <span class="body">\
            <a class="btn btn-primary" target="_blank" href="' + messageObj.content.uri + '">' + messageObj.content.destinationName + '</a>\
        </span>\
    </div>\
</div>';
        return tpl;
    };

    var prepareSuggestionsPost = function (messageObj) {
        var tpl = '';
        tpl += '<div class="post in">\
    <div class="message suggestions">\
        <span class="body">';
        for (var i = 0; i < messageObj.content.suggestions.length; i++) {
            var title = messageObj.content.suggestions[i].title;
            tpl += '\t\t\t<a class="btn btn-primary btn-sm" href="javascript:Benner.IABennerChat.sendMessage(\'' + title + '\')">' + title + '</a>';
        }
        tpl += '\t\t</span>\
    </div>\
</div>';
        return tpl;
    };

    var saveBreak = function () {
        var lastItem = getLastMessage();
        if (lastItem && lastItem.source !== 'break') {
            var breakMessage = new ChatMessage('', 'break', getFormatedDate(), 'break', null);
            appendMessage(breakMessage);
            saveChatHistory(breakMessage);
        }
    };

    var saveChatHistory = function (messageRecord) {
        var chatHistory = getChatHistory();
        if (!chatHistory)
            chatHistory = [];

        chatHistory.push(messageRecord);
        sessionStorage.setItem('iabenner-chat-history', JSON.stringify(chatHistory));
    };

    var handleSlimScroll = function () {
        var wrapper = $('#iabenner-chat .iabenner-sidebar-wrapper');
        var wrapperChat = wrapper.find('.iabenner-sidebar-chat');

        var chatUsersHeight = wrapper.height() - 50;

        var chatMessages = wrapperChat.find('.iabenner-sidebar-chat-user-messages');
        var chatMessagesHeight = chatUsersHeight - wrapperChat.find('.iabenner-sidebar-chat-user-form').outerHeight(true);

        App.destroySlimScroll(chatMessages);
        chatMessages.attr("data-height", chatMessagesHeight);
        App.initSlimScroll(chatMessages);
    };

    var handleToggler = function () {
        $('#menuAtalhos #ia-benner').css({ display: 'inline-block' });
        $('.iabenner-sidebar-toggler,.iabenner-toggler').click(function (e) {
            var wrapper = $('#iabenner-chat .iabenner-sidebar-wrapper');
            wrapper.toggleClass('iabenner-sidebar-open');

            $('#iabenner-chat').toggleClass('iabenner-open', wrapper.hasClass('iabenner-sidebar-open'));

            if (wrapper.hasClass('iabenner-sidebar-open')) {
                $('body').removeClass('page-quick-sidebar-open');
                saveBreak();
                setTimeout(focusOnInput, 100);
                setTimeout(scrollToBottom, 150);
            }
            handleSlimScroll();
        });
    };

    var focusOnInput = function () {
        var wrapper = $('#iabenner-chat .iabenner-sidebar-wrapper');
        var wrapperChat = wrapper.find('.iabenner-sidebar-chat');
        var input = wrapperChat.find('.iabenner-sidebar-chat-user-form .form-control');
        input.focus();
        setTimeout(function () { moveCaretToEnd(input[0]); }, 10);
    };

    var moveCaretToEnd = function (input) {
        var strLength = input.value.length;

        if (input.setSelectionRange !== undefined) {
            input.setSelectionRange(strLength, strLength);
        }
    };

    var scrollToBottom = function () {
        var wrapper = $('#iabenner-chat .iabenner-sidebar-wrapper');
        var wrapperChat = wrapper.find('.iabenner-sidebar-chat');
        var chatContainer = wrapperChat.find('.iabenner-sidebar-chat-user-messages');
        chatContainer.slimScroll({
            scrollTo: (chatContainer[0].scrollHeight + 100) + 'px'
        });
    };

    var handleChat = function () {
        App.addResizeHandler(handleSlimScroll);
        var wrapper = $('#iabenner-chat .iabenner-sidebar-wrapper');
        var wrapperChat = wrapper.find('.iabenner-sidebar-chat');

        var handleChatMessagePost = function (e) {
            e.preventDefault();

            var input = wrapperChat.find('.iabenner-sidebar-chat-user-form .form-control');

            var text = input.val();
            if (text.length === 0)
                return;

            sendMessage(text);

            input.val("");
        };

        wrapperChat.find('.iabenner-sidebar-chat-user-form .btn').click(handleChatMessagePost);
        wrapperChat.find('.iabenner-sidebar-chat-user-form .form-control').keydown(function (e) {
            if (e.which === 13) {
                handleChatMessagePost(e);
                return false;
            }
        });
    };

    var sendMessage = function (text) {

        var lastItem = getLastMessage();
        if (lastItem) {
            var now = new Date();
            var lastTime = parseDate(lastItem.time);
            var seconds = (now.getTime() - lastTime) / 1000;

            if (seconds > 15 * 60) {
                saveBreak();
            }
        }

        var message = new ChatMessage(text, 'text', getFormatedDate(), 'user', usernameInitials);
        saveChatHistory(message);
        appendMessage(message);

        historyIndex = 0;

        var requestBody = {
            message: text,
            user: Page.userName || 'benner-user',
        };

        var sessionId = getSessionId();
        if (sessionId) {
            requestBody.sessionId = sessionId;
        }

        $('#iabenner-writing-notification').show();
        $.ajax({
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify(requestBody),
            url: Page.getApplicationPath() + 'api/v1/iabenner/message',
            success: function (data) {
                if (!data)
                    return;

                if (data.sessionId) {
                    setSessionId(data.sessionId);
                }

                var answerHtml = renderMarkdown(data.resposta || '');
                var botMessage = new ChatMessage(answerHtml, 'text', getFormatedDate(), 'bot', assistantNickname);
                saveChatHistory(botMessage);
                appendMessage(botMessage);

                if (data.referencias && Object.keys(data.referencias).length > 0) {
                    var refsHtml = '<div class="iabenner-refs"><span class="iabenner-refs-title">Referências:</span>';
                    Object.keys(data.referencias).forEach(function (url) {
                        refsHtml += '<a class="iabenner-ref-link" href="' + url + '" target="_blank">' + data.referencias   [url] + '</a>';
                    });
                    refsHtml += '</div>';
                    var refsMessage = new ChatMessage(refsHtml, 'text', getFormatedDate(), 'bot', assistantNickname);
                    saveChatHistory(refsMessage);
                    appendMessage(refsMessage);
                }
            },
            error: function (xhr) {
                var msg = 'Olá! No momento estou com um problema técnico. Tente novamente em alguns instantes.';
                if (xhr.responseJSON) {
                    var serverMsg = xhr.responseJSON.Message || xhr.responseJSON.message;
                    if (serverMsg && serverMsg !== 'An error has occurred.') {
                        msg = serverMsg;
                    } else if (xhr.responseJSON.ExceptionMessage) {
                        msg = xhr.responseJSON.ExceptionMessage;
                    }
                }
                var errorMessage = new ChatMessage(msg, 'text', getFormatedDate(), 'bot', assistantNickname);
                appendMessage(errorMessage);
            },
            complete: function () {
                $('#iabenner-writing-notification').hide();
            }
        });
    };

    var appendMessage = function (message) {
        var post = preparePost(message);
        post = $(post);

        var wrapper = $('#iabenner-chat .iabenner-sidebar-wrapper');
        var wrapperChat = wrapper.find('.iabenner-sidebar-chat');
        var chatContainer = wrapperChat.find('.iabenner-sidebar-chat-user-messages');
        chatContainer.append(post);
        scrollToBottom();
    };

    var handleKeyShortcuts = function () {
        var wrapper = $('#iabenner-chat .iabenner-sidebar-wrapper');
        var wrapperChat = wrapper.find('.iabenner-sidebar-chat');
        var input = wrapperChat.find('.iabenner-sidebar-chat-user-form .form-control');

        input.keydown(function (e) {
            if (e.keyCode === 38) { // Up
                setInputFromHistory('up');
            } else if (e.keyCode === 40) { // Down
                setInputFromHistory('down');
            }
        });
    };

    var setInputFromHistory = function (direction) {
        var lastIndex = historyIndex;
        if (direction === 'up') {
            historyIndex++;
        } else if (direction === 'down') {
            if (historyIndex > 0)
                historyIndex--;
        } else {
            return;
        }

        if (historyIndex === lastIndex)
            return;

        var wrapper = $('#iabenner-chat .iabenner-sidebar-wrapper');
        var wrapperChat = wrapper.find('.iabenner-sidebar-chat');
        var input = wrapperChat.find('.iabenner-sidebar-chat-user-form .form-control');

        if (historyIndex === 0) {
            input.val(typedMessage);
        } else {
            if (lastIndex === 0)
                typedMessage = input.val();

            var history = getUserHistory();
            var reverseHistory = history.reverse();

            if (historyIndex > reverseHistory.length) {
                historyIndex = reverseHistory.length;
            }

            input.val(reverseHistory[historyIndex - 1]);
        }
        setTimeout(function () { moveCaretToEnd(input[0]); }, 10);
    };

    var getUserHistory = function () {
        var history = getChatHistory();
        var result = [];
        for (var i = 0; i < history.length; i++) {
            if (history[i].source === 'user') {
                result.push(history[i].content);
            }
        }
        return result;
    };

    var openWithInitialMessage = function (message) {
        sendMessage(message);
        $('.iabenner-toggler').click();
    };

	return {
		init: function (message) {
			var chatDom = $('#iabenner-chat');

			if (chatDom.length > 0) {
				$.ajax({
					type: 'GET',
					url: Page.getApplicationPath() + 'api/v1/iabenner/',
					dataType: 'json',
					success: function (config) {
						if (!config || !config.visible) return;

						assistantNickname = 'IA Benner';
						getUsernameInfo();
						create('IA Benner');
						handleToggler();
						handleChat();
						handleKeyShortcuts();

						if (!config.enabled) {
							var reason = config.reason || 'A IA Benner não está disponível no momento.';
							var msg = new ChatMessage(reason, 'text', getFormatedDate(), 'bot', assistantNickname);
							appendMessage(msg);
							var wrapper = $('#iabenner-chat .iabenner-sidebar-wrapper');
							wrapper.find('.iabenner-sidebar-chat-user-form .form-control').prop('disabled', true).attr('placeholder', '');
							wrapper.find('.iabenner-sidebar-chat-user-form .btn').prop('disabled', true);
							return;
						}

						recoverChatHistory();
						if (message !== undefined) {
							openWithInitialMessage(message);
						}
						initialized = true;
					}
				});
			}
		},
		sendMessage: function (message) {
			if (initialized) {
				sendMessage(message);
			}
		}
	};

}();

export default IABennerChat;
